import React from 'react';

const Banner = ({ text }) => {
  if (!text) return null;

  return (
    <div className="bg-black text-white text-center py-2 px-4 rounded-lg mb-4">
      {text}
    </div>
  );
};

export default Banner;
